export class HttpResponse {
  /**
   * @param {AxiosResponse<T>} response
   * @param {object} requestConfig
   */
  constructor(response, requestConfig) {
    this.response = response;
    this.requestConfig = requestConfig;
  }

  getBody() {
    return this.response.data;
  }
}
